import { LayerDefinition } from './types';

export const smokeDefinition: LayerDefinition = {
  id: 'smoke',
  name: 'Wildfire Smoke',
  category: 'environment',
  categoryLabel: 'Environmental & Air Quality',
  icon: '🌫️',
  description: 'Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.',
  sourceModels: ['raqdps (Canadian AQ)', 'rrfs (Smoke)', 'hrrr (3km Smoke)'],
  outputModels: ['Smoke density .pmtiles per model (Surface & Column levels)'],
  config: {
    levels: ['surface', 'column'],
    defaultModel: 'hrrr'
  }
};

export default smokeDefinition;
